"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productTrialService = void 0;
const product_trial_service_1 = require("./product-trial-service");
const query_client_1 = require("../query-client");
exports.productTrialService = new product_trial_service_1.ProductTrialService({
    resource: 'product-trial',
    parentResources: [],
    middleware: [],
    queryClient: query_client_1.queryClient,
});
